import React, { ReactNode } from 'react';
import { cn } from '../cn';
import {
  pageTitleClasses,
  sectionTitleClasses,
  pageHeaderClasses,
} from '../recipes/typography';

export function PageTitle({
  children,
  className,
  ...attrs
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h1 className={cn(pageTitleClasses, className)} {...attrs}>
      {children}
    </h1>
  );
}

export function SectionTitle({
  children,
  className,
  as: Tag = 'h3',
  ...attrs
}: React.HTMLAttributes<HTMLHeadingElement> & {
  as?: 'h2' | 'h3' | 'h4';
}) {
  return (
    <Tag className={cn(sectionTitleClasses, className)} {...attrs}>
      {children}
    </Tag>
  );
}

export function PageHeader({
  title,
  action,
  className,
}: {
  title: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn(pageHeaderClasses, className)}>
      {typeof title === 'string' ? <PageTitle>{title}</PageTitle> : title}
      {action}
    </div>
  );
}
